import api from "./Api";

class TransportadoraEnderecoService {
  GetTransportadoraEndereco(payload) {
    return api.get("/v1/transportadoraEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTransportadoraEndereco(payload) {
    return api.post("/v1/transportadoraEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutTransportadoraEndereco(payload) {
    return api.put("/v1/transportadoraEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTransportadoraEndereco(payload) {
    return api
      .delete("/v1/transportadoraEndereco/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetTransportadoraEnderecoOData(payload) {
    return api
      .get("/OData/TransportadoraEndereco" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new TransportadoraEnderecoService();
